import React, { useEffect, useState } from "react";
import _ from 'lodash';
import { motion } from "framer-motion";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";

import { useUser, usePopup, useData, useMenu, useLang, usePrompt, useLoading } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";
import consts from '../libs/consts';
import { getSlideValue, lang, loadImage, toSlideValue } from '../utils/utils';
import * as APIS from '../utils/service.js'

import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";
import Modal from "../components/Modal.js";

/**
 * 이미지 만들기
 */
export default function Menu1() {

    const navigate = useNavigate();
    const location = useLocation();

    const { isLoading, setLoading } = useLoading();

    const { menu, getMenu } = useMenu();
    const { promptList, setPromptList } = usePrompt();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();

    const [prompt, setPrompt] = useState("");       // 프롬프트
    const [styleType, setStyleType] = useState(0); // 콘텐츠 유형 idx
    const [styleIndex, setStyleIndex] = useState(0); // 이미지 스타일 index
    const [isStyleUpload, setIsStyleUpload] = useState(false); // 파일 업로드 모드
    const [styleFile, setStyleFile] = useState(null); // 이미지 스타일 파일obj
    const [selResolution, setselResolution] = useState(0);  // 해상도 idx
    const [seed, setSeed] = useState(""); // 시드값 텍스트 숫자
    const [selSampler, setselSampler] = useState(0); // 샘플러 idx
    const [negaPrompt, setNegaPrompt] = useState(""); //네거티브 프롬프트

    const [moreView, setMoreView] = useState(false) // 더많이 보기

    const [promtStr, setpromtStr] = useState(50); // 프롬프트 반영정도
    const [styleStr, setstyleStr] = useState(50); // 스타일 반영정도
    const [stepStr, setstepStr] = useState(50); // 스텝값 설정하기

    const [share, setShare] = useState(false);

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);
    const randPrompt = () => {
        if (promptList.length > 0) {
            let selectIndex = _.random(promptList.length - 1)
            setPrompt(promptList[selectIndex]);
        }
    }

    const promptDataFunc = () => {
        APIS.post('/config/prompts').then(({ data }) => {
            setPromptList({
                key: "promptList",
                value: data
            })
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const defaultSetOption = (configData) => {
        let error = false
        if ("option_selector_contents" in configData) {
            setStyleType(configData.option_selector_contents[0]?.idx)
        } else {
            error = true
        }

        if ("option_image_style" in configData) {
            setStyleIndex(0)
        } else {
            error = true
        }

        if ("option_image_resolution" in configData) {
            setselResolution(configData.option_image_resolution[2]?.idx) // 3= 1024x1024
        } else {
            error = true
        }

        if ("option_selector_sampler" in configData) {
            setselSampler(configData.option_selector_sampler[0]?.idx)
        } else {
            error = true
        }

        if ("option_slide" in configData) {
            setpromtStr(configData.option_slide.prompt?.default)
            setstyleStr(configData.option_slide.style?.default)
            setstepStr(configData.option_slide.step?.default)
        } else {
            error = true
        }
        if (error) setConfigError(error)


        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const makeImageFunc = () => {
        if (configError) {
            setModal({
                ...modal,
                open: true,
                message: <>
                    <p style={{ textAlign: "center" }}>load config error</p>
                    <p style={{ textAlign: "center" }}>please retry.</p>
                </>
            })
            return;
        }

        let sendData = {
            prompt: prompt,
            contentType: styleType,
            imageStyle: 0,
            resolution: selResolution,
            sampler: selSampler,
            promptStrength: 5,
            styleStrength: 1,
            step: 50,
            seed: seed,
            negativePrompt: negaPrompt,
            share: !share
        }

        if (!sendData.prompt) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_prompt" })
            })
            return;
        }

        if (isStyleUpload) {
            if (!styleFile) {
                setModal({
                    ...modal,
                    open: true,
                    message: getLang({ key: "error_input_style" })
                })
                return;
            }
            sendData.imageStyle = styleFile
        } else {
            sendData.imageStyle = config.option_image_style[styleIndex].idx
        }

        sendData.promptStrength = Number(promtStr)
        sendData.styleStrength = Number(styleStr)
        sendData.step = Number(stepStr)

        console.log("🚀 ~ makeBtnClick ~ sendData:", sendData)

        setLoading(true);
        // setTimeout(() => {
        //     setLoading(false);
        //     // navigate("/myart_history")
        // }, 1000)
        // return;
        APIS.post("/aiImage/generator", sendData).then(({ data }) => {
            if (data) console.log("/aiImage/generator:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            console.log(data, getLang({ key: data.msgkey }));
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.prompt) {
            setPrompt(artData?.prompt)
        }

        if (artData?.negativePrompt) {
            setNegaPrompt(artData?.negativePrompt)
        }


        if (artData?.contentType) {
            let data = configData?.option_selector_contents?.find(v => v.value == artData?.contentType)
            console.log("🚀 ~ setLoadFunc ~ data:", data)
            if (data) {
                setStyleType(data.idx);
            }
        }

        if (artData?.imageStyle) {
            let dataIndex = configData?.option_image_style?.findIndex(v => v.value == artData?.imageStyle)
            console.log("🚀 ~ setLoadFunc ~ dataIndex:", dataIndex)
            if (dataIndex >= 0) {
                setStyleIndex(dataIndex)
            }
        } else if (artData?.imageStyleFile) {
            setIsStyleUpload(true);
            let imageData = await loadImage(consts.imgUrl + artData?.imageStyleFile)
            setStyleFile(imageData)
        }

        if (artData?.width && artData?.height) {
            let data = configData?.option_image_resolution?.find(v => v.title_sub.indexOf(`${artData?.width} x ${artData?.height}`) >= 0)
            if (data) {
                setselResolution(data.idx);
            }
        }

        if (artData?.seed) {
            setSeed(artData?.seed)
        }

        if (artData?.sampler) {
            let data = configData?.option_selector_sampler?.find(v => v.value == artData?.sampler)
            if (data) {
                setselSampler(data.idx);
            }
        }

        if (typeof artData?.promptStrength == "number") {
            setpromtStr(artData?.promptStrength)
        }

        if (typeof artData?.styleStrength == "number") {
            setstyleStr(artData?.styleStrength)
        }

        if (typeof artData?.step == "number") {
            setstepStr(artData?.step)
        }
    }

    useEffect(() => {
        promptDataFunc();
        configDataFunc();
        // console.log("asdasdasd:", getLang({ key: getMenu({ idx: 1 })?.title_key }))
    }, [])


    const [modal, setModal] = useState(consts.defaultModalValue)

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            {getMenu(1)}
                            <LangText id={getMenu({ idx: 1 })?.title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 1 })?.info_key} />
                        </p>
                    </div>
                    {/* <img className="thumb" src={consts.imgUrl + getMenu({ idx: 1 })?.image?.ko} /> */}
                    {/* <img className="thumb" src={images.block_img} /> */}
                    <div className="thumb">
                        {/* <img className={"on"} src={consts.imgUrl + getMenu({ idx: 1 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 1 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    {/* 프롬프트 작성 */}
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_prompt_set" /></p>
                                <p className="body1"><LangText id="info_image_prompt" /></p>
                            </div>

                        </div>

                        <div className="option_box">
                            <div className="prompt_text_box">
                                <InputSimple
                                    className="border_none"
                                    value={prompt}
                                    setValue={setPrompt}
                                    placeholder="Describe the image you want to generate."
                                />
                                <div className="or_box"><LangText id="text_or" /></div>
                                <Button
                                    image={images.generate_text_white}
                                    title={getLang({ key: "btn_random" })}
                                    type={3}
                                    onClick={randPrompt}
                                />
                            </div>
                        </div>
                    </div>
                    {/* 성성 콘텐츠 유형 */}
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_content_type" /></p>
                            </div>
                        </div>
                        <Radio
                            value={styleType}
                            setValue={setStyleType}
                            options={config?.option_selector_contents?.map((v, i) => {
                                return { value: v.idx, label: getLang({ key: v.title_key }) }
                            })} />
                    </div>

                    {/* 이미지 스타일 설정 */}
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_set_image_style" /></p>
                                <p className="body1"><LangText id="info_image_style" /></p>
                            </div>

                            <Button title={isStyleUpload ? getLang({ key: "btn_show_style" }) : getLang({ key: "btn_upload_image_style" })} type={2} onClick={() => {
                                setIsStyleUpload(!isStyleUpload)
                            }} />
                        </div>
                        {!isStyleUpload ? <div className="border_box">
                            <p className="body1"><LangText id="text_style_list" /></p>
                            <RadioImage
                                className="mt-12"
                                // options={[
                                //     { title: "스타일옵션#2", imgSrc: images.block_img },
                                // ]}
                                options={config?.option_image_style?.map((v) => {
                                    return { title: getLang({ key: v?.title_key }), imgSrc: `${consts.imgUrl}${v?.imgPath}` }
                                })}
                                current={styleIndex}
                                onChange={setStyleIndex}
                            />
                        </div> : <InputFileDrag
                            name="drag-file"
                            value={styleFile}
                            setValue={setStyleFile}
                        />}
                    </div>
                    {/* 해상도 설정 */}
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_image_resolution" /></p>
                                <p className="body1"><LangText id="info_image_resolution" /></p>
                            </div>
                        </div>

                        <div
                            style={{ display: "flex", minWidth: 210 }}
                            className="sel_box">
                            <Selector
                                placeholder={getLang({ key: "text_select" })}
                                options={config?.option_image_resolution?.map(v => {
                                    // return { value: v?.idx, label: `${getLang({ key: v?.title_key })} ${v?.title_sub}` }
                                    return { value: v?.idx, label: <><LangText id={v?.title_key} /> {v?.title_sub}</> }
                                })}
                                value={selResolution}
                                setValue={setselResolution}
                            // options={[
                            //     { value: 1, label: "풍경 (3:2) - 1024 x 682" },
                            //     { value: 2, label: "시네마 (16:9) - 1024 x 576" },
                            //     { value: 3, label: "프로필 (1:1) - 1024 x 1024" },
                            //     { value: 4, label: "숏폼 (9:16) - 576 x 1024" },
                            //     { value: 4, label: "초상화 (2:3) - 682 x 1024" }
                            // ]}
                            />
                        </div>
                    </div>

                    {/* ------------------- more section ---------------------- */}

                    {moreView && <>
                        {/* 시드값 설정 */}
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_set_seed" /></p>
                                    <p className="body1">
                                        <LangText id="info_set_seed1" />
                                        <span className="color-sec"><LangText id="info_set_seed2" /></span>
                                    </p>
                                </div>

                            </div>

                            <InputSimple
                                style
                                valid="num"
                                value={seed}
                                setValue={setSeed}
                                placeholder={getLang({ key: "placeholder_seed" })}
                            />
                        </div>
                        {/* 샘플러 설정 */}
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_sampler_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_sampler_set1" />
                                        <span className="color-sec"><LangText id="info_sampler_set2" /></span>
                                    </p>
                                </div>

                            </div>
                            <div
                                style={{ display: "flex", minWidth: 210 }}
                                className="sel_box">
                                <Selector
                                    options={config?.option_selector_sampler?.map(v => {
                                        //getLang({ key: v?.title_key })
                                        return { value: v?.idx, label: getLang({ key: v?.title_key }) }
                                        // return { value: v?.idx, label: `${<LangText id={v?.title_key} />} ` }
                                    })}
                                    // options={[
                                    //     { value: 1, label: "풍경 (3:2) - 1024 x 682" },
                                    //     { value: 2, label: "시네마 (16:9) - 1024 x 576" },
                                    //     { value: 3, label: "프로필 (1:1) - 1024 x 1024" },
                                    //     { value: 4, label: "숏폼 (9:16) - 576 x 1024" },
                                    //     { value: 4, label: "초상화 (2:3) - 682 x 1024" }
                                    // ]}
                                    value={selSampler}
                                    setValue={setselSampler}
                                />
                            </div>
                        </div>

                        {/* 프롬프트 반영 정도 */}
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_prompt_strength" /></p>
                                    <p className="body1">
                                        <LangText id="info_prompt_strength" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_ai_art" })}
                                endText={getLang({ key: "text_prompt" })}
                                step={config.option_slide?.prompt?.step}
                                min={config.option_slide?.prompt?.min || 0}
                                max={config.option_slide?.prompt?.max || 100}
                                value={promtStr}
                                setValue={setpromtStr}
                                tickerValue={promtStr}
                            />
                        </div>

                        {/* 네거티브 프롬프트 */}
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_negative_propmt" /></p>
                                    <p className="body1">
                                        <LangText id="info_negative_propmt" />
                                    </p>
                                </div>
                            </div>

                            <InputSimple
                                style
                                value={negaPrompt}
                                setValue={setNegaPrompt}
                                placeholder={getLang({ key: "info_negative_propmt" })}
                            />
                        </div>

                        {/* 스타일 반영정도 */}
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_style_ref_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_style_ref_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_str_min" })}
                                endText={getLang({ key: "text_str_max" })}
                                step={config.option_slide?.style?.step}
                                min={config.option_slide?.style?.min || 0}
                                max={config.option_slide?.style?.max || 100}
                                value={styleStr}
                                setValue={setstyleStr}
                                tickerValue={styleStr}
                            />
                        </div>

                        {/* 스텝값 */}
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_step_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_stop_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_fast_create" })}
                                endText={getLang({ key: "text_high_quality" })}
                                step={config.option_slide?.step?.step}
                                min={config.option_slide?.step?.min || 0}
                                max={config.option_slide?.step?.max || 100}
                                value={stepStr}
                                setValue={setstepStr}
                                tickerValue={stepStr}
                            />
                        </div>
                    </>}


                    {/* ------------------- more section ---------------------- */}

                    <div className="more_box" >
                        <div className="btn_box"
                            onClick={() => {
                                setMoreView(!moreView)
                            }}>
                            <p className={`title${moreView ? " focus" : ""}`}>
                                <LangText id="text_more_option" />
                            </p>
                        </div>
                    </div>
                </div>

                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_image", replace: { key: "{0}", val: getMenu({ idx: 1 })?.point } })}
                        round
                        onClick={makeImageFunc}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        checked={share}
                        onChange={(e) => {
                            setShare(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
